import React from 'react'
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import UserInfo from '../components/Frontend/OnBoarding/UserInfo';
import DomainPreferences from '../components/Frontend/OnBoarding/DomainPreferences';
import AccountPreferences from '../components/Frontend/OnBoarding/AccountPreferences';
import Congratulations from '../components/Frontend/OnBoarding/Congratulations';


export const onBoardingRoutes = (
  <>
  <Route path="/onboarding" element={<MainLayout />}>
    <Route index path="user_info" element={<UserInfo />} />
    <Route path="domain_preferences" element={<DomainPreferences />} />
    <Route path="account_preferences" element={<AccountPreferences />} />
    <Route path="congratulations" element={<Congratulations />} />
  </Route>
  </>
);
